import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DOCUMENTATION_AREA_ROUTES } from "../routes/Navigation";
import {
  getDocumentationAreaRemovalReason,
  getUnavailableLocationState,
} from "../utils/getDocumentationAreaRemovalReason";

// Single place deciding which screen an unhandled request error ends in: the unavailable screen for
// a removed actor/access, the generic error screen for anything else
export const useNavigateToErrorScreen = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return useCallback(
    (error: unknown) => {
      const reason = getDocumentationAreaRemovalReason(error);
      navigate(
        {
          pathname: reason
            ? DOCUMENTATION_AREA_ROUTES.DOCUMENTATION_AREA_UNAVAILABLE_SCREEN
            : DOCUMENTATION_AREA_ROUTES.ERROR_SCREEN,
          search,
        },
        { state: getUnavailableLocationState(reason), replace: true },
      );
    },
    [navigate, search],
  );
};
